module.exports = __webpack_public_path__ + "img/dubi_no.baa25800.png";